/*
 * KinkySabine – Cart Feedback
 * Sorgt dafür, dass nach "In den Warenkorb legen" (egal ob über das
 * Standard-Produktformular, den Sticky-Add-to-Cart-Button oder den
 * Bundle-Kauf-Button auf der Produktseite):
 *
 *   1. eine sichtbare Bestätigungs-Nachricht (Toast) erscheint, und
 *   2. der Warenkorb-Zähler im Ultimate Header (.uh-badge) sofort
 *      aktualisiert wird, ohne dass ein Seiten-Refresh nötig ist.
 *
 * Hört auf die vom Theme (theme.js) und von den KS-Skripten bereits
 * ausgelösten Events: ajaxProduct:added / ajaxProduct:error /
 * cart:updated / cart:refresh / theme:cart:refresh.
 */
(function () {
  'use strict';

  function getBadgeEls() {
    return document.querySelectorAll('[data-uh-cart-badge]');
  }

  function updateBadge(count) {
    getBadgeEls().forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-hidden', count <= 0);
    });
  }

  function updateDrawerSummary(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart || typeof cart.total_price !== 'number') return;

    var threshold = parseInt(drawer.dataset.freeShippingThreshold, 10);
    if (!Number.isFinite(threshold) || threshold <= 0) return;

    var fill = drawer.querySelector('.ks-cart-progress__fill');
    if (fill) {
      var percent = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      fill.style.width = percent + '%';
    }

    var message = drawer.querySelector('.ks-cart-motivation__text');
    if (!message) return;

    if (cart.total_price >= threshold) {
      message.innerHTML = '<strong>Perfekt.</strong> Kostenloser Versand aktiviert.';
    } else {
      var missing = threshold - cart.total_price;
      var formatted = window.theme && theme.Currency
        ? theme.Currency.formatMoney(missing, theme.settings.moneyFormat)
        : (missing / 100).toFixed(2).replace('.', ',') + ' €';
      message.innerHTML = '<strong>Noch ' + formatted + '</strong> bis kostenloser Versand.';
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateBadge(cart.item_count);
          updateDrawerSummary(cart);
        }
      })
      .catch(function () {});
  }

  var toastTimer = null;
  function showToast(message, isError) {
    if (!message) return;
    var toast = document.querySelector('.ks-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ks-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.remove('is-visible');

    // Reflow erzwingen, damit die Einblend-Animation bei erneutem
    // Antippen des Buttons zuverlässig neu startet.
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3200);
  }

  function extractProductTitle(evt) {
    try {
      var detail = evt && evt.detail;
      if (detail && detail.product && detail.product.title) return detail.product.title;
    } catch (e) {}
    return '';
  }

  function onAdded(evt) {
    refreshCartCount();
    var title = extractProductTitle(evt);
    showToast(title ? title + ' wurde in den Warenkorb gelegt.' : 'Artikel wurde in den Warenkorb gelegt.', false);
  }

  function onError(evt) {
    var msg = 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
    try {
      if (evt && evt.detail && evt.detail.errorMessage) msg = evt.detail.errorMessage;
    } catch (e) {}
    showToast(msg, true);
  }

  function onCartUpdated(evt) {
    try {
      var cart = evt && evt.detail && evt.detail.cart;
      if (cart && typeof cart.item_count === 'number') {
        updateBadge(cart.item_count);
        updateDrawerSummary(cart);
        return;
      }
    } catch (e) {}
    refreshCartCount();
  }

    // Produktkarten mit .ks-quickadd als AJAX-Formular behandeln.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form.ks-quickadd[action*="/cart/add"]')) return;

    evt.preventDefault();
    if (form.dataset.ksAjaxSubmitting === 'true') return;

    var submitButton = form.querySelector('[type="submit"]');
    form.dataset.ksAjaxSubmitting = 'true';
    if (submitButton) submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw payload;
          return payload;
        });
      })
      .then(function (product) {
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: Object.assign({ tags: [] }, product) }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      })
      .catch(function (error) {
        var message = error && (error.description || error.message);
        form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          bubbles: true,
          detail: { errorMessage: message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.' }
        }));
      })
      .then(function () {
        delete form.dataset.ksAjaxSubmitting;
        if (submitButton) submitButton.disabled = false;
      });
  }, true);

// "capture: true" ist wichtig: theme.js löst ajaxProduct:added/error
  // teils direkt auf dem Formular-Element aus (event bubbelt dort
  // nicht zwingend bis zum document hoch). Im Capture-Modus bekommt
  // der document-Listener das Event trotzdem mit, auf dem Weg nach
  // unten zum eigentlichen Ziel.
  document.addEventListener('ajaxProduct:added', onAdded, true);
  document.addEventListener('ajaxProduct:error', onError, true);
  document.addEventListener('cart:updated', onCartUpdated, true);
  document.addEventListener('cart:refresh', refreshCartCount, true);
  document.addEventListener('theme:cart:refresh', refreshCartCount, true);

  // Zusätzliches eigenes Event (z.B. von ks-quick-add.js) ebenfalls abfangen.
  document.addEventListener('ks:cart:added', onAdded, true);
})();

/* KinkySabine – sichtbare Shoptexte und mobile Widgets (16.10.2026)
 * Wirkt ausschließlich auf gerenderten Kundentext. URLs, Handles, Assets,
 * Formulardaten, Tracking und App-Konfigurationen bleiben unverändert.
 */
(function () {
  'use strict';

  var replacements = {
    'FUER': 'FÜR', 'Fuer': 'Für', 'fuer': 'für',
    'UEBERSICHT': 'ÜBERSICHT', 'Uebersicht': 'Übersicht', 'uebersicht': 'übersicht',
    'BESTELLUEBERSICHT': 'BESTELLÜBERSICHT', 'Bestelluebersicht': 'Bestellübersicht', 'bestelluebersicht': 'bestellübersicht',
    'INTENSITAET': 'INTENSITÄT', 'Intensitaet': 'Intensität', 'intensitaet': 'intensität',
    'QUALITAET': 'QUALITÄT', 'Qualitaet': 'Qualität', 'qualitaet': 'qualität',
    'hoechste': 'höchste', 'Hoechste': 'Höchste', 'Ansprueche': 'Ansprüche', 'ansprueche': 'ansprüche',
    'Gruene': 'Grüne', 'gruene': 'grüne', 'heiss': 'heiß', 'Heiss': 'Heiß',
    'uebernimmt': 'übernimmt', 'Uebernimmt': 'Übernimmt', 'ueber': 'über', 'Ueber': 'Über',
    'vollstaendig': 'vollständig', 'Vollstaendig': 'Vollständig', 'vollstaendige': 'vollständige', 'vollstaendiger': 'vollständiger',
    'waehrend': 'während', 'Waehrend': 'Während', 'moechte': 'möchte', 'moechten': 'möchten', 'Moechtest': 'Möchtest',
    'koennen': 'können', 'Koennen': 'Können', 'koennte': 'könnte', 'koerper': 'körper', 'Koerper': 'Körper',
    'groesser': 'größer', 'Groesser': 'Größer', 'groessere': 'größere', 'groesste': 'größte', 'Groesste': 'Größte',
    'laenger': 'länger', 'Laenger': 'Länger', 'haeufig': 'häufig', 'Haeufig': 'Häufig',
    'natuerlich': 'natürlich', 'Natuerlich': 'Natürlich', 'unterstuetzt': 'unterstützt', 'Unterstuetzt': 'Unterstützt',
    'Zubehoer': 'Zubehör', 'zubehoer': 'zubehör', 'ausschliesslich': 'ausschließlich', 'Ausschliesslich': 'Ausschließlich',
    'gleichermassen': 'gleichermaßen', 'Einschraenkung': 'Einschränkung', 'einschraenkung': 'einschränkung',
    'durchgaengig': 'durchgängig', 'schmaelere': 'schmälere', 'Guertel': 'Gürtel', 'guertel': 'gürtel',
    'staerkere': 'stärkere', 'staerker': 'stärker', 'Aesthetik': 'Ästhetik', 'aesthetik': 'ästhetik',
    'Groesse': 'Größe', 'groesse': 'größe', 'Groessen': 'Größen', 'groessen': 'größen',
    'Abhaengigkeit': 'Abhängigkeit', 'abhaengig': 'abhängig', 'Prioritaet': 'Priorität', 'prioritaet': 'priorität',
    'aussen': 'außen', 'Aussen': 'Außen', 'Guenstig': 'Günstig', 'guenstig': 'günstig',
    'gruendlich': 'gründlich', 'Gruendlich': 'Gründlich', 'Haende': 'Hände', 'haende': 'hände',
    'schoen': 'schön', 'Schoen': 'Schön', 'schoener': 'schöner', 'verfuegbar': 'verfügbar', 'Verfuegbar': 'Verfügbar',
    'zurueck': 'zurück', 'Zurueck': 'Zurück', 'zusaetzlich': 'zusätzlich', 'Zusaetzlich': 'Zusätzlich',
    'ermoeglicht': 'ermöglicht', 'Ermoeglicht': 'Ermöglicht', 'benoetigt': 'benötigt', 'Benoetigt': 'Benötigt',
    'sorgfaeltig': 'sorgfältig', 'Sorgfaeltig': 'Sorgfältig', 'ausgewaehlt': 'ausgewählt', 'Ausgewaehlt': 'Ausgewählt',
    'vielfaeltig': 'vielfältig', 'Vielfaeltig': 'Vielfältig', 'persoenlich': 'persönlich', 'Persoenlich': 'Persönlich',
    'moeglich': 'möglich', 'Moeglich': 'Möglich', 'ungewoehnlich': 'ungewöhnlich', 'gewoehnen': 'gewöhnen',
    'beruecksichtigen': 'berücksichtigen', 'Beruecksichtigen': 'Berücksichtigen',
    'spaeter': 'später', 'Spaeter': 'Später', 'gemaess': 'gemäß', 'Gemaess': 'Gemäß',
    'Strasse': 'Straße', 'strasse': 'straße', 'Strassen': 'Straßen', 'strassen': 'straßen',
    'Fuesse': 'Füße', 'fuesse': 'füße', 'Fuss': 'Fuß', 'fuss': 'fuß',
    'ATMOSPHAERE': 'ATMOSPHÄRE', 'Atmosphaere': 'Atmosphäre', 'atmosphaere': 'atmosphäre',
    'MOEBEL': 'MÖBEL', 'Moebel': 'Möbel', 'moebel': 'möbel',
    'RUECKGABE': 'RÜCKGABE', 'Rueckgabe': 'Rückgabe', 'rueckgabe': 'rückgabe',
    'VERFUEHRUNG': 'VERFÜHRUNG', 'Verfuehrung': 'Verführung', 'verfuehrung': 'verführung',
    'WAEHLE': 'WÄHLE', 'Waehle': 'Wähle', 'waehle': 'wähle'
  };

  var formalPhrases = [
    [/\bErfahren Sie\b/g, 'Erfahre'], [/\bKlicken Sie\b/g, 'Klicke'],
    [/\bMelden Sie sich\b/g, 'Melde dich'], [/\bRegistrieren Sie sich\b/g, 'Registriere dich'],
    [/\bHinterlassen Sie\b/g, 'Hinterlasse'], [/\bBitte beachten Sie\b/g, 'Bitte beachte'],
    [/\bWählen Sie\b/g, 'Wähle'], [/\bGeben Sie\b/g, 'Gib'], [/\bFügen Sie\b/g, 'Füge'],
    [/\bBestätigen Sie\b/g, 'Bestätige'], [/\bVersuchen Sie\b/g, 'Versuche'],
    [/\bSie müssen\b/g, 'Du musst'], [/\bSie können\b/g, 'Du kannst'], [/\bSie haben\b/g, 'Du hast'],
    [/\bIhre Suche\b/g, 'Deine Suche'], [/\bIhr Einkaufswagen\b/g, 'Dein Warenkorb'],
    [/\bIhr Warenkorb\b/g, 'Dein Warenkorb'], [/\bIhr Kommentar\b/g, 'Dein Kommentar'],
    [/\bIhre Bestellung\b/g, 'Deine Bestellung'], [/\bIhr Konto\b/g, 'Dein Konto'],
    [/\bIhre Adressen\b/g, 'Deine Adressen'], [/\bIhre Adresse\b/g, 'Deine Adresse'],
    [/\bIhr Passwort\b/g, 'Dein Passwort'], [/\bvon Ihnen\b/g, 'von dir'],
    [/\bIhnen eine E-Mail\b/g, 'dir eine E-Mail'], [/\bin Ihrem Warenkorb\b/g, 'in deinem Warenkorb']
  ];

  var words = Object.keys(replacements).sort(function (a, b) { return b.length - a.length; });
  var wordPattern = new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + words.map(function (word) {
    return word.replace(/[.*+?^$()|[\]\\]/g, '\\$&');
  }).join('|') + ')(?=$|[^A-Za-zÄÖÜäöüß])', 'g');

  function correctText(value) {
    if (!value || typeof value !== 'string') return value;
    var corrected = value.replace(wordPattern, function (_, lead, word) { return lead + replacements[word]; });
    formalPhrases.forEach(function (entry) { corrected = corrected.replace(entry[0], entry[1]); });
    return corrected;
  }

  function correctElement(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,textarea,[contenteditable="true"]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var next = correctText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[aria-label],[title],[placeholder]').forEach(function (el) {
        ['aria-label', 'title', 'placeholder'].forEach(function (name) {
          if (el.hasAttribute(name)) {
            var oldValue = el.getAttribute(name);
            var newValue = correctText(oldValue);
            if (newValue !== oldValue) el.setAttribute(name, newValue);
          }
        });
      });
    }
  }

  function hideMobileChatActivator() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (document.querySelector('[data-mobile-open][aria-expanded="true"]')) return;
    document.querySelectorAll('shopify-chat').forEach(function (host) {
      var roots = [host];
      if (host.shadowRoot) roots.push(host.shadowRoot);
      roots.forEach(function (root) {
        root.querySelectorAll('[part~="activator"], button.activator, button[aria-label="Chat. Chat öffnen"], [data-testid*="chat-button" i]').forEach(function (el) {
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.style.setProperty('position', 'fixed', 'important');
          el.style.setProperty('left', '-10000px', 'important');
          el.style.setProperty('width', '1px', 'important');
          el.style.setProperty('height', '1px', 'important');
        });
      });
    });
  }

  function installWidgetRules() {
    if (document.getElementById('ks-storefront-fixes')) return;
    var style = document.createElement('style');
    style.id = 'ks-storefront-fixes';
    style.textContent = 'body.template-index #casa-widget{display:none!important;visibility:hidden!important;pointer-events:none!important}@media(max-width:767px){shopify-chat::part(activator){opacity:0!important;pointer-events:none!important;position:fixed!important;left:-10000px!important;width:1px!important;height:1px!important}}';
    document.head.appendChild(style);
  }

  var pendingCorrectionRoots = new Set();
  var correctionScheduled = false;

  function flushCorrections() {
    correctionScheduled = false;
    var roots = Array.from(pendingCorrectionRoots);
    pendingCorrectionRoots.clear();
    roots.forEach(function (root) { correctElement(root); });
    hideMobileChatActivator();
  }

  function scheduleCorrections(root) {
    if (root) pendingCorrectionRoots.add(root);
    if (correctionScheduled) return;
    correctionScheduled = true;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(flushCorrections, { timeout: 1500 });
    } else {
      window.setTimeout(flushCorrections, 250);
    }
  }

  function start() {
    installWidgetRules();
    hideMobileChatActivator();
    scheduleCorrections(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scheduleCorrections(node);
          else if (node.nodeType === 3 && node.parentElement) scheduleCorrections(node.parentElement);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', hideMobileChatActivator);
    window.setTimeout(hideMobileChatActivator, 500);
    window.setTimeout(hideMobileChatActivator, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
